<template>
  <div class="section-h">
    <div v-if="!isLoading">
      <div class="is-underlined">
        <h1 class="is-size-2">{{honoree.first_name}} {{honoree.last_name}}</h1>
        <h2 class="is-size-4">
          {{honoree.year}} &mdash;
          <span v-if="honoree.sports.length" v-for="(sport, idx) in honoree.sports" :key="sport.id">{{sport.name}}<span v-if="idx < honoree.sports.length - 1">, </span></span>
        </h2>
      </div>
    </div>
    <div class="detail-scroller push push-extra">
      <div class="flex flex-center">
        <div class="swiper-button-prev" slot="button-prev">
          <svg width="20" height="30" viewBox="0 0 20 30">
            <polyline points="20,0 0,15 20,30" style="fill:none;stroke:white;stroke-width:4" />
          </svg>
        </div>
        <swiper v-if="hasMedia" ref="profileSwiper" :options="swiperOptions">
          <swiper-slide v-for="(obj, idx) in honoree.photos" :key="'img'+idx">
            <div class="profile-slide">
              <img :src="obj.photo">
            </div>
          </swiper-slide>
          <swiper-slide v-for="(obj, idx) in honoree.videos" :key="'video'+idx">
            <a class="video-slide" :href="obj.url">
              <div>
                <img :src="`https://img.youtube.com/vi/${getIdFromURL(obj.url)}/hqdefault.jpg`">
                <img src="/images/play-button.png">
              </div>
            </a>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-next" slot="button-next">
          <svg width="20" height="30" viewBox="0 0 20 30">
            <polyline points="0,0 20,15 0,30" style="fill:none;stroke:white;stroke-width:4" />
          </svg>
        </div>
      </div>
      <div class="swiper-pagination push-top" slot="pagination"></div>
      <div class="copy push-top space-top" v-html="honoree.biography"></div>
    </div>
    <wall-info :honoree="honoree"></wall-info>
    <p v-if="hasMedia && !honoree.biography || !hasMedia && honoree.biography">To add content or report missing content, please contact steveb@sdhoc.com</p>
    <a class="back is-uppercase is-bordered has-text-white has-text-centered" href="#" @click="$router.go(-1);">Back to List</a>
    <app-nav></app-nav>
  </div>
</template>

<script>
import Endpoints from '@/components/Endpoints.js';
import filters from '../filters';
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import { getIdFromURL } from 'vue-youtube-embed/lib/vue-youtube-embed.umd.js';
import SanitizeHtml from 'sanitize-html';

export default {
  data() {
    return {
      endpoint: Endpoints.List.find(
        obj => obj.slug === this.$route.params.honor
      ),
      swiperOptions: {
        watchOverflow: true,
        setWrapperSize: true,
        //autoHeight: true,
        pagination: {
          clickable: true,
          el: '.swiper-pagination'
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }        
      },
      hasMedia: false
    };
  },
  computed: {
    isLoading() {
      return this.$store.state.pending[this.endpoint.getProperty];
    },
    honoree() {
      let honoree = this.$store.state[this.endpoint.getProperty];
      honoree.biography = SanitizeHtml(honoree.biography);
      return honoree;
    }
  },
  created() {
    this.$store.dispatch(this.endpoint.getAction, {
      params: { id: this.$route.params.id, honor: this.$route.params.honor }
    }).then(() => {     
      this.hasMedia = 
        !!(this.honoree.videos && this.honoree.videos.length) || 
        !!(this.honoree.photos && this.honoree.photos.length);

        console.log(this.honoree);
    });
  },
  methods: {
    getIdFromURL
  },
  components: { swiper, swiperSlide }
};
</script>

<style>
.swiper-wrapper {
  margin-bottom: 45px;
}
.swiper-button-prev, .swiper-button-next {
  background: none;
}
.swiper-pagination {
  position: relative;
}
.swiper-pagination-bullet {
  background: #fff;
  opacity: 0.5;
  width: 10px;
  height: 10px;
  margin-left: 20px;
}

.swiper-pagination-bullet-active {
  background: #fff;
  opacity: 1;
  width: 10px;
  height: 10px;
  margin-left: 20px;
}
</style>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/helpers.scss';

h1 {
  line-height: 1.5rem;
}

h2 {
  color: $gold;
}

a {
  display: block;
}

.profile-slide,
.video-slide {
  height: 300px;
}

.profile-slide {
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-slide {
  > div {
    position: relative;
    height: 100%;
    img {
      position: absolute;
      width: 100%;
      + img {
        width: auto;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) scale(.5);
      }
    }
  }
}
.copy {
  max-height: 500px;
  overflow-y: auto;
  -webkit-mask-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 1) 2%,
    rgba(0, 0, 0, 0.94) 98%,
    rgba(0, 0, 0, 0) 100%
  );
  mask-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 1) 2%,
    rgba(0, 0, 0, 0.94) 98%,
    rgba(0, 0, 0, 0) 100%
  );
}
.back {
  max-width: 50%;
  margin: 25px auto;
}
</style>
